import React from 'react'
import { motion } from 'framer-motion';
import { FaCross, FaHeart, FaShare } from 'react-icons/fa';
import { useModal } from '../contexts/ModalContext';
import { RiCheckLine, RiCloseLine } from 'react-icons/ri';
import { CircularProgress, duration } from '@mui/material';
import useMunicipality from '../hooks/useMunicipality';
import useAuth from '../hooks/useAuth';
import { useQuery } from 'react-query';
import { addCitizenReceipt, getMunicipalityByLocality } from '../api';
import NotFind from '../pages/NotFind';

const ActionBoxCoupon = ({ supportsSaving = false }) => {
    const { setModal, unSetModal } = useModal()

    const { municipality } = useMunicipality();

    const { login, user, isAuthenticated, updateUserValues } = useAuth();

    var coupon = 0;


    return (
        <div className="container flex flex-col sm:w-5/6 md:w-5/6">

            <div className='flex items-center '>
                <img
                    src={'../assets/images/recycle-coupon-ic.svg'}
                    alt={''}
                    className={`object-contain p-2  h-12 animate-waving-hand`}
                />
                <h3 className="text-3xl font-bold text-gray-700 ">Έχω κουπόνι</h3></div>
            <h3 className="text-lg font-normal text-gray-700 pb-7">'Καταχώρησε τον αριθμό κουπονιού και κέρδισε πόντους.</h3>

            <div className='grid  mt-6 gap-y-12 md:gap-x-10 grid-cols-1 lg:grid-cols-2 xl:gap-x-32 '>



                <motion.div
                    initial={{ rotate: 25, scale: 0, opacity: 0 }}

                    animate={{ rotate: 0, scale: 1, opacity: 1 }}
                    transition={{
                        type: "spring",
                        stiffness: 260,
                        damping: 20
                    }}
                    className='rounded-3xl  p-[5px] bg-gradient-to-r from-app_yellow  to-app_brown  drop-shadow-2xl shadow-xl '>
                    <div className="relative justify-between flex flex-col  cursor-pointer rounded-3xl  bg-white">
                        <div className="absolute -top-6 flex items-center justify-center rounded-full  sm:w-[45%] h-12 left-1/2 transform -translate-x-1/2  bg-gray-100 border-[6px] drop-shadow-xl  border-white">
                            <div className='m-2 text-sm md:text-base font-semibold'>Ανακύκλωσης</div>
                        </div>
                        <div className='p-8  w-full h-[280px] flex justify-center text-center '>
                            <img
                                src={'https://followgreen.fra1.digitaloceanspaces.com/Content/css/assets/recycle-coupon-yellow.svg'}
                                // src={img}
                                alt={''}
                                className={`object-contain p-2 translate-y-5 mr-5`}
                            />
                        </div >
                        <div className=" absolute -top-6 flex items-center justify-center bg-opacity-100 rounded-full shadow-md opacity-100 w-14 h-14 -right-3 bg-gradient-to-b from-app_yellow  to-app_brown ">
                            <div className=" flex items-center justify-center font-bold text-gray-800 bg-white border-2 border-white rounded-full shadow-inner w-11 h-11 shadow-gray-200 text-md border-bg-gradient-to-r from-cyan-500 to-blue-500 hover:animate-ping">
                                150
                            </div>
                        </div>



                        <div className="flex flex-col items-center text-center justify-evenly w-full">

                            <div className="flex justify-center text-center w-11/12 h-20">
                                <p className="text-sm font-semibold text-gray-500 ">Έλαβες κουπόνι ανακύκλωσης από τον Δήμο;</p>
                            </div>

                            <div className='sm:flex '>

                                <div className="flex justify-center shadow-[inset_0px_6px_12px_rgba(0,0,0,0.3)] border-dashed border-[2px] border-gray-400  py-2 md:mx-4 w-32 sm:w-44 my-5 text-center bg-white rounded-xl md:w-[150px]">

                                    <input 
                                    onChange={
                                        (e) => {
                                                

                                            e.persist()
                                            coupon = e.target.value;  

                                            console.log(coupon)
                                               
                                        
                                        }
                                    }
                                    
                                    placeholder='000000' className="text-center font-semibold text-gray-900 w-32 bg-transparent"></input>
                                </div>
                                <div
                                    className="flex justify-center  py-2 md:mx-2 my-5 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_yellow  to-app_brown   transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg  hover:shadow-orange-300  hover:-translate-y-1 hover:scale-110 duration-150"
                                    onClick={async () => {
                                        if (!isAuthenticated) {
                                            setModal(
                                                <div className='flex flex-col items-center justify-center py-5'>
                                                    <motion.div
                                                        initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                        exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                                        animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                        transition={{
                                                            damping: 20,
                                                            duration: 0.35
                                                        }}
                                                        className='border-4 border-app_red rounded-full w-20 h-20 flex justify-center items-center'>

                                                        <div><RiCloseLine className='w-16 h-16 text-app_red'></RiCloseLine></div>
                                                    </motion.div>
                                                    <div className='font-bold text-lg text-center pt-5'>Κάνε εγγραφή ή συνδέσου για να κερδίσεις πόντους</div>
                                                    <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                        onClick={() => { unSetModal() }}
                                                    >OK</div>
                                                </div>
                                            )
                                        }
                                        else {

                                            const receiptData =
                                            {
                                                CitizenId: user.citizenId,
                                                coupon: coupon,
                                                ReceiptTypeId:2,

                                            }
                                            const recycleResponse = await addCitizenReceipt(receiptData)
                                            if (recycleResponse.status === 2) {
                                                updateUserValues()
                                                setModal(
                                                    <div className='flex flex-col items-center justify-center py-5'>
                                                        <motion.div
                                                            initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                            exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                                            animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                            transition={{
                                                                damping: 20,
                                                                duration: 0.35
                                                            }}
                                                            className='border-4 border-app_green_light rounded-full w-20 h-20 flex justify-center items-center'>

                                                            <div><RiCheckLine className='w-16 h-16 text-app_green_light'></RiCheckLine></div>
                                                        </motion.div>
                                                        <div className='font-bold text-lg text-center pt-5'>Ευχαριστούμε για την καταχώρηση της πράσινης ενέργειας  στον Δήμο σου. Μόλις κέρδισες 150 πόντους.</div>
                                                        <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                            onClick={() => { unSetModal() }}
                                                        >OK</div>
                                                    </div>
                                                )
                                            }
                                            else {
                                                setModal(
                                                    <div className='flex flex-col items-center justify-center py-5'>
                                                         <motion.div
                                                            initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                            exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                                            animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                            transition={{
                                                                damping: 20,
                                                                duration: 0.35
                                                            }}
                                                            className='border-4 border-app_red rounded-full w-20 h-20 flex justify-center items-center'>

                                                            <div><RiCloseLine className='w-16 h-16 text-app_red'></RiCloseLine></div>
                                                        </motion.div>
                                                        <div className='font-bold text-lg text-center pt-5'>Ο κωδικός δεν είναι σωστός.</div>
                                                        <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                            onClick={() => { unSetModal() }}
                                                        >OK</div>
                                                    </div>
                                                )
                                            }
                                        }
                                    }}
                                >

                                    Καταχώρηση

                                </div>

                            </div>




                        </div>
                    </div>
                </motion.div>


                {!supportsSaving ? null :
                    // if(muni)
                    <motion.div
                        initial={{ rotate: 25, scale: 0, opacity: 0 }}

                        animate={{ rotate: 0, scale: 1, opacity: 1 }}
                        transition={{
                            type: "spring",
                            stiffness: 260,
                            damping: 20
                        }}
                        className='rounded-3xl  p-[5px] bg-gradient-to-r from-app_yellow  to-app_brown  drop-shadow-2xl shadow-xl '>
                        <div className="relative justify-between flex flex-col  cursor-pointer rounded-3xl  bg-white">
                            <div className="absolute -top-6 flex items-center justify-center rounded-full  sm:w-[45%] h-12 left-1/2 transform -translate-x-1/2  bg-gray-100 border-[6px] drop-shadow-xl  border-white">
                                <div className='m-2 text-sm md:text-base font-semibold'>Πράσινης ενέργειας</div>
                            </div>
                            <div className='p-8  w-full h-[280px] flex justify-center text-center '>
                                <img
                                    src={'https://followgreen.fra1.digitaloceanspaces.com/Content/css/assets/recycle-coupon-green.svg'}
                                    // src={img}
                                    alt={''}
                                    className={`object-contain p-2 translate-y-5 mr-5`}
                                />
                            </div >
                            <div className=" absolute -top-6 flex items-center justify-center bg-opacity-100 rounded-full shadow-md opacity-100 w-14 h-14 -right-3 bg-gradient-to-b from-app_yellow  to-app_brown ">
                                <div className=" flex items-center justify-center font-bold text-gray-800 bg-white border-2 border-white rounded-full shadow-inner w-11 h-11 shadow-gray-200 text-md border-bg-gradient-to-r from-cyan-500 to-blue-500 hover:animate-ping">
                                    150
                                </div>
                            </div>



                            <div className="flex flex-col items-center text-center justify-evenly w-full">

                                <div className="flex justify-center text-center w-11/12 h-20">
                                    <p className="text-sm font-semibold text-gray-500 ">Έλαβες κουπόνι από επιλεγμένα σημεία του Δήμου ή χρησιμοποιώντας τη δημοτική συγκοινωνία;</p>
                                </div>

                                <div className='sm:flex '>

                                    <div className="flex justify-center shadow-[inset_0px_6px_12px_rgba(0,0,0,0.3)] border-dashed border-[2px] border-gray-400  py-2 md:mx-4 w-32 sm:w-44 my-5 text-center bg-white rounded-xl md:w-[150px]">

                                        <input onChange={
                                            (e) => {
                                                    

                                                e.persist()
                                                coupon = e.target.value;  

                                                console.log(coupon)
                                                   
                                            
                                            }
                                        } placeholder='000000' className="text-center font-semibold text-gray-900 w-32 bg-transparent"></input>
                                    </div>
                                    <div
                                        className="flex justify-center  py-2 md:mx-2 my-5 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_yellow  to-app_brown   transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg  hover:shadow-orange-300  hover:-translate-y-1 hover:scale-110 duration-150"
                                        onClick={async () => {
                                            if (!isAuthenticated) {
                                                setModal(
                                                    <div className='flex flex-col items-center justify-center py-5'>
                                                        <motion.div
                                                            initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                            exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                                            animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                            transition={{
                                                                damping: 20,
                                                                duration: 0.35
                                                            }}
                                                            className='border-4 border-app_red rounded-full w-20 h-20 flex justify-center items-center'>

                                                            <div><RiCloseLine className='w-16 h-16 text-app_red'></RiCloseLine></div>
                                                        </motion.div>
                                                        <div className='font-bold text-lg text-center pt-5'>Κάνε εγγραφή ή συνδέσου για να κερδίσεις πόντους</div>
                                                        <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                            onClick={() => { unSetModal() }}
                                                        >OK</div>
                                                    </div>
                                                )
                                            }
                                            else {

                                                const receiptData =
                                                {
                                                    CitizenId: user.citizenId,
                                                    coupon: coupon,
                                                    ReceiptTypeId: 2

                                                }
                                                const recycleResponse = await addCitizenReceipt(receiptData)
                                                if (recycleResponse.status === 2) {
                                                    updateUserValues()
                                                    setModal(
                                                        <div className='flex flex-col items-center justify-center py-5'>
                                                            <motion.div
                                                                initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                                exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                                                animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                                transition={{
                                                                    damping: 20,
                                                                    duration: 0.35
                                                                }}
                                                                className='border-4 border-app_green_light rounded-full w-20 h-20 flex justify-center items-center'>

                                                                <div><RiCheckLine className='w-16 h-16 text-app_green_light'></RiCheckLine></div>
                                                            </motion.div>
                                                            <div className='font-bold text-lg text-center pt-5'>Ευχαριστούμε για την καταχώρηση της πράσινης ενέργειας  στον Δήμο σου. Μόλις κέρδισες 150 πόντους.</div>
                                                            <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                                onClick={() => { unSetModal() }}
                                                            >OK</div>
                                                        </div>
                                                    )
                                                }
                                                else {
                                                    setModal(
                                                        <div className='flex flex-col items-center justify-center py-5'>
                                                             <motion.div
                                                            initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                            exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                                            animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                            transition={{
                                                                damping: 20,
                                                                duration: 0.35
                                                            }}
                                                            className='border-4 border-app_red rounded-full w-20 h-20 flex justify-center items-center'>

                                                            <div><RiCloseLine className='w-16 h-16 text-app_red'></RiCloseLine></div>
                                                        </motion.div>
                                                            <div className='font-bold text-lg text-center pt-5'>Ο κωδικός δεν είναι σωστός.</div>
                                                            <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                                onClick={() => { unSetModal() }}
                                                            >OK</div>
                                                        </div>
                                                    )
                                                }
                                            }
                                        }}
                                    >

                                        Καταχώρηση

                                    </div>

                                </div>




                            </div>
                        </div>
                    </motion.div>
                }



            </div>

        </  div>
    )
}

export default ActionBoxCoupon